import { h } from 'preact';
import PropTypes from 'prop-types';

import { getClassNames } from '../../../../utils/classnames-utils';
import Wrapper from '../../1-foundation/wrapper/wrapper';

import { loaderModifierList, wrapperModifierList } from './props-list';

const DEFAULT_LOADER_MODIFIERS = ['infinite-scrolling'];

const Loader = ({ modifiers = DEFAULT_LOADER_MODIFIERS, withWrapper = false, wrapperModifiers = [], style }) => {
  const wrapperClassNames = getClassNames('s-loader-wrapper', wrapperModifiers);
  const loaderClassNames = getClassNames('c-loader', modifiers);

  return (
    <Wrapper isWrapping={withWrapper} className={wrapperClassNames}>
      <div className={loaderClassNames} style={style}>
        <div className="c-loader__item" />
        <div className="c-loader__item" />
        <div className="c-loader__item" />
      </div>
    </Wrapper>
  );
};

Loader.propTypes = {
  modifiers: PropTypes.arrayOf(PropTypes.oneOf(loaderModifierList)),
  wrapperModifiers: PropTypes.arrayOf(PropTypes.oneOf(wrapperModifierList)),
  withWrapper: PropTypes.bool,
  style: PropTypes.object,
};

export default Loader;
